export const zh = {
    'nav.today': "今日概览",
    'nav.calendar': "需求日历",
    'nav.rates': "房价与规则",
    'nav.automation': "自动化中心",
    'nav.audit': "审计日志",
    'nav.settings': "设置",
    'sidebar.status': "已连接",
    'stat.occupancy': "入住率",
    'stat.adr': "平均房价 (ADR)",
    'stat.revpar': "平均客房收益 (RevPAR)",
    'stat.revenue': "预估收入",
    'stat.trend.vsLastWeek': "对比上周",
    'stat.trend.onPace': "进度正常",
    'dashboard.actions.title': "推荐操作",
    'dashboard.actions.empty': "未找到推荐操作。",
    'filter.all': "全部",
    'filter.pricing': "定价",
    'filter.restriction': "限制条件",
    'action.approve': "批准并推送",
    'action.reject': "拒绝",
    'action.risk.low': "低风险",
    'action.risk.medium': "中风险",
    'action.risk.high': "高风险",
    'action.label.current': "当前",
    'action.label.proposed': "建议",
    'action.metric.impact': "影响",
    'action.metric.why': "原因",
    'action.status.executed': "自动执行",
    'header.search': "搜索...",
    'header.logout': "退出登录",
    'auto.level.title': "自动驾驶级别",
    'auto.level.manual': "手动",
    'auto.level.manual.desc': "您批准每一项建议。",
    'auto.level.assisted': "辅助",
    'auto.level.assisted.desc': "自动批准低风险更改。审查重大变动。",
    'auto.level.auto': "全自动",
    'auto.level.auto.desc': "AI 在您的限制范围内 24/7 管理价格。",
    'auto.level.active': "激活",
    'auto.guardrails.title': "安全护栏",
    'auto.guardrails.maxIncrease': "每日最大涨幅",
    'auto.guardrails.maxIncrease.desc': "防止价格剧烈波动。",
    'auto.guardrails.maxDecrease': "每日最大跌幅",
    'auto.guardrails.maxDecrease.desc': "防止意外低价倾销。",
    'auto.guardrails.minRate': "最低底价",
    'auto.guardrails.minRate.desc': "绝不低于此价格销售 (净价)。",
    'auto.emergency.title': "紧急控制",
    'auto.emergency.label': "紧急停止",
    'auto.emergency.desc': "立即暂停所有自动化。",
    'auto.emergency.btn': "暂停系统",
    'rates.filter.all': "所有房型",
    'rates.filter.next14': "未来 14 天",
    'rates.export': "导出",
    'audit.table.time': "时间",
    'audit.table.actor': "操作者",
    'audit.table.category': "类别",
    'audit.table.action': "操作",
    'audit.table.details': "详情",
    'audit.table.status': "状态",
    'settings.pms.title': "PMS 连接",
    'settings.pms.connected': "已连接到",
    'settings.pms.disconnect': "断开连接",
    'settings.account.title': "账户",
    'settings.account.role': "角色",
    'settings.restart': "重新开始入门指引",
    'onboard.title': "连接您的 PMS",
    'onboard.desc': "选择您的物业管理系统以同步库存。",
    'onboard.connecting': "连接中...",
    'onboard.connect': "连接",
    'onboard.success.title': "设置完成！",
    'onboard.success.desc': "**SynthHotel Berlin** 现已同步。",
    'onboard.success.sub': "已导入 3 个房型，14 个房价计划和 243 个未来预订。",
    'onboard.btn.dashboard': "前往仪表盘",
    'action.dynamic.weekend.title': "提高周末房价",
    'action.dynamic.weekend.desc': "周六入住率 > 75%，需求强劲（24小时内 +12 间）。",
    'action.dynamic.minstay.title': "启用 2 晚最低连住",
    'action.dynamic.minstay.desc': "泰勒·斯威夫特演唱会宣布。防止 1 晚住宿阻塞库存。",
    'action.dynamic.distress.title': "降低房价（需求疲软）",
    'action.dynamic.distress.desc': "下周二入住率 35%。竞争对手降价 €10。",
    'action.dynamic.gap.title': "填补空缺：移除 CTA",
    'action.dynamic.gap.desc': "发现单晚空缺。移除“禁止到达”限制以出售房间。",
};
